export const registerSW = () => {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
};

export default defineNuxtPlugin(() => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(registerSW, { timeout: 5000 });
  } else {
    setTimeout(registerSW, 200);
  }
});
